export const currencies = {
  1: "$",
  2: "€",
  3: "₽",
};
